import React from "react";
import { Button, Snackbar, Alert } from "@mui/material";
import "./App";
import AppRouter from "./routes/index";
import { AuthProvider } from "./contexts/AuthContext";
import { ThemeContextProvider } from "./contexts/ThemeContext";
import { InstallProvider, useInstall } from "./contexts/InstallContext";

// Külön komponens a Snackbar kezelésére, hogy használhassa a useInstall hook-ot
const InstallBanner = () => {
  const { isInstallable, installApp, showInstallBanner, setShowInstallBanner } = useInstall();
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);

  // Ha a context jelzi, hogy megjelent a banner (init), akkor kinyitjuk a snackbart
  React.useEffect(() => {
    if (showInstallBanner) {
      setSnackbarOpen(true);
    }
  }, [showInstallBanner]);

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
    setShowInstallBanner(false); // Contextben is jelezzük, hogy látta
  };

  const handleInstallClick = () => {
    installApp();
    handleCloseSnackbar();
  };

  if (!isInstallable) return null;

  return (
    <Snackbar
      open={snackbarOpen}
      autoHideDuration={null}
      onClose={handleCloseSnackbar}
      anchorOrigin={{ vertical: "top", horizontal: "center" }} // Felülre tesszük
      sx={{ mt: 7 }} // Hogy ne takarja ki teljesen a header-t
    >
      <Alert
        onClose={handleCloseSnackbar}
        severity="info"
        sx={{ width: "100%", boxShadow: 3 }}
        action={
          <Button color="inherit" size="small" onClick={handleInstallClick}>
            TELEPÍTÉS
          </Button>
        }
      >
        Telepítsd az alkalmazást a jobb élményért!
      </Alert>
    </Snackbar>
  );
};

function App() {
  return (
    <ThemeContextProvider>
      <AuthProvider>
        <InstallProvider>
          <div className="App">
            <AppRouter />
            <InstallBanner />
          </div>
        </InstallProvider>
      </AuthProvider>
    </ThemeContextProvider>
  );
}

export default App;


